import React, { HTMLAttributes, useEffect, useState } from 'react';
import { ISigningCase } from 'src/models';
import {
  HeaderContainer,
  SigningCaseBorder,
  SigningCaseTitle,
  Tag,
  TitleContainer,
} from './MvpAppSigningCaseHeader.styles';
import { Subtitle as CardSubtitle } from 'src/components/Card/Title';
import { getMvpAppSigningCaseHeaderColor } from 'src/utils/getSigningCaseHeaderColor';
import { MvpInfoText } from 'src/components/PortalList/PortalDocumentsList/PortalDocumentsList.styles';
import { useUrlParameterCheck } from 'src/utils/useUrlParameterCheck';
import { t } from 'i18next';

interface Props extends HTMLAttributes<HTMLDivElement> {
  title: string;
  subTitle: string;
  status: ISigningCase['status'];
  deadline: string;
  canSign?: boolean;
}

const MvpAppSigningCaseHeader = (props: Props) => {
  const { title, subTitle, status, deadline, ...rest } = props;
  const [caseStatus, setCaseStatus] = useState(status);
  const isFromMvpApp = useUrlParameterCheck('/app');

  useEffect(() => {
    setCaseStatus(status);
  }, [status]);

  const renderMvpInfoText = (s: string) => {
    if (s === 'Signed') {
      return (
        <MvpInfoText text={t('YouHaveSuccessfullySignedTheAgreementMvp')} />
      );
    }

    if (
      (props.canSign && s === 'CancelledBySignatory') ||
      (props.canSign && s === 'Expired')
    ) {
      return (
        <MvpInfoText text={t('YourAgreementRejectedCannotBeSignedInMvpApp')} />
      );
    }

    if (!props.canSign) {
      if (s === 'CancelledBySignatory' || s === 'Expired') {
        return (
          <MvpInfoText
            text={t('YourAgreementRejectedCannotBeSignedInMvpApp')}
          />
        );
      } else {
        return (
          <MvpInfoText text={t('YouMustReviewAllDocumentsBeforeSigning')} />
        );
      }
    }

    return null;
  };

  return (
    <SigningCaseBorder {...rest}>
      <HeaderContainer>
        <Tag
          isFromMvpApp={isFromMvpApp}
          color={getMvpAppSigningCaseHeaderColor(caseStatus)}
          date={deadline}
          status={status}
          data-testid="signing-case-tag"
        />
        <TitleContainer>
          <SigningCaseTitle title={title}>{title}</SigningCaseTitle>
          <CardSubtitle title={subTitle}>{subTitle}</CardSubtitle>
        </TitleContainer>
      </HeaderContainer>
      {renderMvpInfoText(status)}
    </SigningCaseBorder>
  );
};

export default MvpAppSigningCaseHeader;
